import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    minWidth: '200px',
    flexBasis: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

const Info = ({ classes }) => {
  return(
    <div className={classes.root}>
      <Typography>
        Here you can choose from standard templates for your profession or the last 9 bids you've done.
      </Typography>
      <Typography>
        *You can star your favorite bids so they stay at the top.
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Info);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Header/Info.jsx